var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import { Label, OverlayTrigger, Glyphicon, Popover } from 'reaxl';

/**
 *  Displays an inventory label indicating that the listing price was recently reduced
 *  It optionally provides an overlay with additional information when interacted with.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ReducedPrice(_ref) {
  let {
    bsStyle = 'secondary',
    description,
    enableOverlay = false,
    label = 'Reduced Price',
    ...rest
  } = _ref;
  const labelComponent = /*#__PURE__*/_jsxs(Label, {
    "data-cmp": "reducedPrice",
    bsStyle: bsStyle,
    ...rest,
    children: [label, enableOverlay && !!description && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "info",
      className: "margin-left-1 text-valign-baseline"
    })))]
  });
  if (enableOverlay && !!description) {
    return /*#__PURE__*/_jsx(OverlayTrigger, {
      "aria-label": "Reduced Price",
      className: "cursor-pointer",
      placement: "top",
      rootClose: true,
      trigger: "click",
      overlay: /*#__PURE__*/_jsx(Popover, {
        id: "contextual-help-reduced-price",
        children: description
      }),
      children: labelComponent
    });
  }
  return labelComponent;
}
export default ReducedPrice;